import MaterialTableHead, { TableHeadProps } from "@mui/material/TableHead";
import React, { FC } from "react";
import { styled } from "@mui/material/styles";
import {
  COLOR_PICKLE_BLUEWOOD,
  COLOR_WHITE,
  COLOR_ATHENS_GRAY_DARKER_2,
  COLOR_SHUTTLE_GRAY,
} from "../../constants/styles";

interface IProps extends TableHeadProps {
  secondary?: boolean;
}

const StyledTableHead = styled(MaterialTableHead, {
  shouldForwardProp: (prop) => prop !== "secondary",
})`
  background-color: ${(props: any) => (props.secondary ? COLOR_ATHENS_GRAY_DARKER_2 : COLOR_PICKLE_BLUEWOOD)};

  & .MuiTableCell-head {
    color: ${(props: any) => (props.secondary ? COLOR_SHUTTLE_GRAY : COLOR_WHITE)};
    font-size: 12px;
    font-weight: 700;
  }
`;

export const TableHead: FC<IProps> = (props) => <StyledTableHead {...props} />;

TableHead.defaultProps = {
  secondary: false,
};
